var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"std-page-form",class:`std-page-form--${_vm.type}`},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }